// main.js
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Initialize theme before Vue app loads
import { initializeTheme } from './utils/theme'
initializeTheme()

import { createApp } from './bootstrap/app'
import { setupErrorHandlers } from './bootstrap/errorHandlers'

async function init () {
	const { app, router, store } = await createApp()
	setupErrorHandlers(router)
	return { app, router, store }
}

export default init()
